// import React, { useEffect, useState, useRef } from "react";
// import dingSound from "./assets/ding.mp3"; // adjust the path if needed

// const TrackUser = ({ children }) => {
//     const [isInactive, setIsInactive] = useState(false);
//     let timer;
//     const audioRef = useRef(null);






//     useEffect(() => {
//         const accessToken = localStorage.getItem("AccessToken");
//         if (!accessToken) return;

//         const resetTimer = () => {
//             clearTimeout(timer);
//             setIsInactive(false);
//             timer = setTimeout(() => {
//                 setIsInactive(true);

//                 // 🔔 Play sound when popup shows
//                 if (audioRef.current) {
//                     audioRef.current.muted = false; // unmute
//                     audioRef.current.load(); // reload sound
//                     audioRef.current.play().catch((err) => {
//                         console.warn("Autoplay blocked. Will play on next user interaction:", err);
//                     });
//                 }
//             }, 1 * 60 * 10000); // 1 minute
//         };

//         const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
//         events.forEach((event) => window.addEventListener(event, resetTimer));

//         resetTimer();

//         return () => {
//             clearTimeout(timer);
//             events.forEach((event) => window.removeEventListener(event, resetTimer));
//         };
//     }, []);

//     return (
//         <>
//             {children}

//             {/* 🔊 Hidden audio element */}
//             <audio ref={audioRef} src={dingSound} preload="auto" />

//             {isInactive && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: 0,
//                         left: 0,
//                         width: "100%",
//                         height: "100%",
//                         backgroundColor: "rgba(0,0,0,0.6)",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         zIndex: 9999,
//                     }}
//                 >
//                     <div
//                         style={{
//                             background: "#fff",
//                             padding: "20px 30px",
//                             borderRadius: "8px",
//                             textAlign: "center",
//                             boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
//                         }}
//                     >
//                         <h2>You’ve been inactive. alert before log out the user!</h2>
//                         <p>to prevent , Please move your mouse or press a key to continue.</p>
//                         <button
//                             onClick={() => {
//                                 setIsInactive(false);
//                                 if (audioRef.current) {
//                                     audioRef.current.pause();
//                                     audioRef.current.currentTime = 0;
//                                 }
//                             }}
//                             style={{
//                                 marginTop:"10px",
//                                 padding: "8px 16px",
//                                 background: "#007bff",
//                                 color: "#fff",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer",
//                             }}
//                         >
//                             Continue
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default TrackUser;

import React, { useEffect, useState, useRef } from "react";
import dingSound from "./assets/ding.mp3";
import { API_URL } from "src/components/util/config";
const TrackUser = ({ children }) => {
  const [showWarning, setShowWarning] = useState(false);
  const activityTimer = useRef(null);
  const logoutTimer = useRef(null);
  const refreshTimer = useRef(null);
  const audioRef = useRef(null);
  const userIsActive = useRef(true);

  // -----------------------------
  // Helper: Decode JWT
  const parseJwt = (token) => {
    try {
      const base64Payload = token.split(".")[1];
      return JSON.parse(atob(base64Payload));
    } catch {
      return null;
    }
  };

  // -----------------------------
  // Helper: Get Device & Browser Info
  const getDeviceInfo = () => {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    if (ua.includes("Chrome")) browser = "Chrome";
    else if (ua.includes("Firefox")) browser = "Firefox";
    else if (ua.includes("Safari")) browser = "Safari";
    else if (ua.includes("Edge")) browser = "Edge";
    let device = /Mobi|Android/i.test(ua) ? "Mobile" : "Desktop";
    return { device, browser };
  };

  // -----------------------------
  // Refresh Token if User is Active
  const refreshAccessToken = async () => {

    if (!userIsActive.current) {

      return;
    }
    const { device, browser } = getDeviceInfo();
    const Token = localStorage.getItem("AccessToken");
   const refreshToken = localStorage.getItem("RefreshToken");

    try {
      const res = await fetch(`${API_URL}userlogin/refresh`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
           Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify(refreshToken),
      });
      const data = await res.json();
      if (data.IsSuccess) {
        const newToken = data.ResultSet[0]?.AccessToken;
        const newRefreshToken = data.ResultSet[0]?.RefreshToken;
        localStorage.setItem("AccessToken", newToken);
        localStorage.setItem("RefreshToken", newRefreshToken);


        // Reschedule refresh
        scheduleTokenRefresh(newToken, newRefreshToken);
      } else {
        console.warn("❌ Token refresh failed");
      }
    } catch (err) {
      console.error("Error refreshing token:", err);
    }
  };

  // -----------------------------
  // Schedule Token Refresh
  const scheduleTokenRefresh = (accessToken, refreshToken) => {
    const payload = parseJwt(accessToken);
    // if (!payload?.exp) return;

   // const expTime = payload.exp * 1000;
   // const now = Date.now();
    //const refreshTime = expTime - now - 10 * 60 * 1000; // 10 min before expiry
    const refreshTime=  150 * 60 * 1000
    // if (refreshTime <= 0) {
    //   console.warn("⚠️ Token too close to expiry");
    //   return;
    // }

    refreshTimer.current = setTimeout(() => {
      refreshAccessToken(refreshToken);
    }, refreshTime);

   
  };

  // -----------------------------
  // Reset Inactivity Timer
  const resetInactivity = () => {
    userIsActive.current = true;

    clearTimeout(activityTimer.current);
    clearTimeout(logoutTimer.current);
    setShowWarning(false);

    // After 20 min → show warning
    activityTimer.current = setTimeout(() => {
      userIsActive.current = false;
      setShowWarning(true);

      if (audioRef.current) {
        audioRef.current.muted = false;
        audioRef.current.load();
        audioRef.current.play().catch(console.warn);
      }

      // After additional 5 min → logout
      logoutTimer.current = setTimeout(() => {
      
        localStorage.clear();
        sessionStorage.clear();
        
        window.location.reload();
        //window.location.href = "/login";
      }, 2 * 60 * 1000); // 5 min
    }, 20 * 60 * 1000); // 20 min
  };

  // -----------------------------
  // Mount Effect
  useEffect(() => {
    const accessToken = localStorage.getItem("AccessToken");
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!accessToken || !refreshToken) return;

    //Setup events for activity tracking
    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];
    events.forEach((event) => window.addEventListener(event, resetInactivity));
    resetInactivity();

    // Setup token refresh
    scheduleTokenRefresh(accessToken, refreshToken);

    return () => {
      clearTimeout(activityTimer.current);
      clearTimeout(logoutTimer.current);
      clearTimeout(refreshTimer.current);
      events.forEach((event) => window.removeEventListener(event, resetInactivity));
    };
  }, []);

  // -----------------------------
  return (
    <>
      {children}
      <audio ref={audioRef} src={dingSound} preload="auto" />

      {showWarning && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px 30px",
              borderRadius: "8px",
              textAlign: "center",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
            }}
          >
            <h2>⚠️ You've been inactive.</h2>
            <p>You will be logged out soon. Please interact to stay signed in.</p>
            <button
              onClick={() => {
                resetInactivity();
                if (audioRef.current) {
                  audioRef.current.pause();
                  audioRef.current.currentTime = 0;
                }
              }}
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                background: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Continue Session
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TrackUser;

